// extracted by mini-css-extract-plugin
export default {"addRowButtonWrapper":"styles_addRowButtonWrapper__UAw7r","icon":"styles_icon__RCdhT"};